import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";
import OwlCarousel from "react-owl-carousel";
import VideoYoutube from "../partials/home/VideoYoutube";
import BannerText from "../partials/home/BannerText";
// import InterviewCall from "../partials/home/InterviewCall";
import MentorsProfile from "../partials/home/MentorsProfile";
import { useIsVisible } from "../hooks/useIsVisible";
import HiringOrganizations from "../partials/home/HiringOrganizations";
import Projects from "../partials/home/Projects";
import ComparisonWithOther from "../partials/home/ComparisonWithOther";
import CourseReview from "../partials/home/CourseReview";
import Certificates from "../partials/home/Certificates";
import CareerServices from "../partials/home/CareerServices";
import CareerServicesAI from "../partials/home/CareerServicesAI";
import FAQ from "../partials/home/FAQ";
import WhoShouldJoin from "../partials/home/WhoShouldJoin";
import CareerOutcomes from "../partials/home/CareerOutcomes";
import Timeline from "../partials/home/Timeline";
import StudentsPlacedChart from "../partials/home/StudentsPlacedChart";
import PremiumFeeBatchDetails from "../partials/home/PremiumFeeBatchDetails";
import DataScienceBanner from "../partials/home/DataScienceBanner";
import CourseHighlights from "../partials/home/CourseHighlights";
import TestimonialsSection from "../partials/home/TestimonialsSection";
import TestimonialReviews from "../partials/home/TestimonialReviews";
import CommunityPage from "../partials/home/CommunityPage";
import HoliDiscount from "../partials/home/components/HoliDiscount";





//import SimpleSlider from "../partials/home/SimpleSlider";


const profiles = [
  { name: "Anjani Kumar", image: "assets/images/anjani.png", company: "Amazon", logo: "assets/images/amazonicon.png" },
  { name: "Praveen Kumar", image: "assets/images/praveen.jpg", company: "Intel", logo: "assets/images/intel.jpg" },
  { name: "Aman", image: "assets/images/Aman.jpg", company: "Sony", logo: "assets/images/sony.jpg" },
  { name: "Ashish", image: "assets/images/Ashish1.jpg", company: "Vmware", logo: "assets/images/vmware.jpg" },
  { name: "Asha Yadav", image: "assets/images/Asha.jpg", company: "Amazon", logo: "assets/images/amazonicon.png" },
  { name: "Himanshu Mittal", image: "assets/images/Himanshu.jpg", company: "MakeMyTrip", logo: "assets/images/makemytrip.jpeg" },
  { name: "Arpan Banerjee", image: "assets/images/arpan.jpg", company: "WalmartLabs", logo: "assets/images/walmarticon.png" },
  { name: "Shivank Agarwal", image: "assets/images/shivank.png", company: "Microsoft", logo: "assets/images/microsofticon.png" },
  { name: "Gunjan Yadav", image: "assets/images/gunjan.png", company: "Intuit", logo: "assets/images/intuit.jpg" },
  { name: "Vamsi Karuturi", image: "assets/images/vamsi.png", company: "Walmart Labs", logo: "assets/images/walmarticon.png" },
  { name: "Piyush Mittal", image: "assets/images/piyush.png", company: "Microsoft", logo: "assets/images/microsofticon.png" },
  { name: "Salin Gupta", image: "assets/images/salin.png", company: "PayPal", logo: "assets/images/paypal.jpg" },
  { name: "Rishav", image: "assets/images/Rishav-Jha.png", company: "Adobe", logo: "assets/images/adobe.jpg" }
  
  // Add more profiles here
];



const ContinuousSlider = () => {

  return (
    
    <div className="slider">
      <div className="slider-track">
        {profiles.map((profile, index) => (
          <div className="slider-item" key={index}>
            <div className="profile-card">
              <img src={profile.image} alt={profile.name} className="profile-image" />
              <h4 className="profile-name">{profile.name}</h4>
              <img src={profile.logo} alt={profile.company} className="company-logo" />
            </div>
          </div>
        ))}
        {/* Duplicate profiles to make a seamless slider */}
        {profiles.map((profile, index) => (
          <div className="slider-item" key={`dup-${index}`}>
            <div className="profile-card">
              <img src={profile.image} alt={profile.name} className="profile-image" />
              <h4 className="profile-name">{profile.name}</h4>
              <img src={profile.logo} alt={profile.company} className="company-logo" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Footer = () => {
  return (
    <section>
      <div className="footer">
        {/* Contact Section */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>IND: +91 80889-75867</p>
          <p>Email: info@logicmojo.com</p>
          <p>Location: Marathahalli, Bangalore, India</p>
          <div className="social-icons">
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/ios-filled/20/4a148c/facebook.png" alt="Facebook" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/ios-filled/20/4a148c/twitter.png" alt="Twitter" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/ios-filled/20/4a148c/instagram.png" alt="Instagram" />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <img src="https://img.icons8.com/ios-filled/20/4a148c/linkedin.png" alt="LinkedIn" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Company</h3>
          <ul>
            <li>
              <a href="https://logicmojo.com/about_us" target="_blank" rel="noopener noreferrer">
                About Us
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/success-story" target="_blank" rel="noopener noreferrer">
                Success Stories
              </a>
            </li>
            <li>
              <a href="#Contact">Contact Us</a>
            </li>
            <li>
              <a href="https://logicmojo.com/terms_condition" target="_blank" rel="noopener noreferrer">
                Terms & Condition
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/privacy_policy" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/refund_policy" target="_blank" rel="noopener noreferrer">
                Return & Refund Policy
              </a>
            </li>
          </ul>
        </div>

        {/* Resources */}
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li>
              <a href="https://logicmojo.com/datascience-course/" target="_blank" rel="noopener noreferrer">
                Data Science Course
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/full-stack-developer-course/" target="_blank" rel="noopener noreferrer">
                Full Stack Developer Course
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/complete-course" target="_blank" rel="noopener noreferrer">
                DSA System Design
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/java-interview-questions" target="_blank" rel="noopener noreferrer">
                Java Interview Questions
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/amazon-interview-questions" target="_blank" rel="noopener noreferrer">
                Amazon Interview Questions
              </a>
            </li>
          </ul>
        </div>

        {/* Partnership Section */}
        <div className="footer-section">
          <h3>Partnership</h3>
          <ul>
            <li>
              <a href="https://logicmojo.com/become_a_mentor" target="_blank" rel="noopener noreferrer">
                Become a Mentor
              </a>
            </li>
            <li>
              <a href="https://logicmojo.com/blog" target="_blank" rel="noopener noreferrer">
                Blog
              </a>
            </li>
            <li>
              <a href="#" target="_blank" rel="noopener noreferrer">
                Talent Solutions
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          © 2025 Logicmojo Pvt. Ltd. All rights reserved. |{" "}
          <a href="#" target="_blank" rel="noopener noreferrer">
            Terms of Use
          </a>{" "}
          |{" "}
          <a href="#" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
        </p>
      </div>
    </section>
  );
};

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="container d-flex justify-content-between align-items-center">
        <div className="contact-info">
          <span className="contact-email">
            <i className="fa fa-envelope"></i> info@logicmojo.com
          </span>
          <span className="contact-phone">
            <i className="fa fa-phone"></i> +91 8088975867
          </span>
        </div>
      </div>
    </div>
  );
};

function Home() {
  const [toggle, setTg] = useState();
  const [activeSection, setActiveSection] = useState("");
  const sectionRef = useRef(null);
  const [countdownText, setCountdownText] = useState("");

  const [isNavFixed, setIsNavFixed] = useState(false);
  const [isNavFixed2, setIsNavFixed2] = useState(false);
  const navRef = useRef(null);
  const navRef2 = useRef(null);

  const overviewSection = useRef();
  const isVisibleOverview = useIsVisible(overviewSection);
  


  const syllabusInDetail = useRef();
  const isVisibleSyllabus = useIsVisible(syllabusInDetail);
  
  const placementSection = useRef();
  const isVisiblePlacement = useIsVisible(placementSection);
  
  const certificationSection = useRef();
  const isVisibleCertification = useIsVisible(certificationSection);

  const projectSection = useRef();
  const isVisibleProject = useIsVisible(projectSection);

  const mentorSection = useRef();
  const isVisibleMentor = useIsVisible(mentorSection);

  const coursereviewSection = useRef();
  const isVisibleCoursereview = useIsVisible(coursereviewSection);

  const feeSection = useRef();
  const isVisibleFee = useIsVisible(feeSection);

  const faqSection = useRef();
  const isVisibleFaq = useIsVisible(faqSection);

  const contactSection = useRef();
  const isVisibleContact = useIsVisible(contactSection);


  const [width, setWidth] = useState(window.innerWidth);

   useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const activeItem = document.querySelector('.scrollble-tab-li.active');
    if (activeItem) {
      const list = document.getElementById('scrollble-ul-page');
      const scrollLeft = activeItem.offsetLeft - (list.offsetWidth / 2) + (activeItem.offsetWidth / 2);
      setTimeout(() => {
        list.scrollLeft = scrollLeft;
      }, 750)
      
    }
  }, [
    isVisibleOverview, isVisibleSyllabus, isVisibleProject , isVisiblePlacement, isVisibleCertification, isVisibleMentor, isVisibleCoursereview, isVisibleFee, isVisibleFaq,isVisibleContact 
  ])

  useEffect(() => {

    const navContainer = navRef.current;

    const toggleSyllabusButtonsVisibility = (entries) => {
      const isVisible = entries[0].isIntersecting;
      navContainer.classList.toggle("sticky-section", isVisible);
    };


    const isSmallScreen = window.innerWidth < 767;

    if (isSmallScreen) {
      const navContainerHeight = navContainer.clientHeight;
      const navThreshold = 200 / navContainerHeight;


      const options = {
        threshold: [navThreshold],
      };

      if (navThreshold <= 0.5) {
        const navObserver = new IntersectionObserver(
          toggleSyllabusButtonsVisibility,
          options
        );
        navObserver.observe(navContainer);
      } else {
        console.error("Syllabus threshold exceeds 1. Please adjust the value.");
      }


    }

    // Return empty cleanup function if not a small screen
    return () => {
      const navObserver = new IntersectionObserver(
        toggleSyllabusButtonsVisibility
      );
      navObserver.unobserve(navContainer);
    };
  }, []);

  useEffect(() => {

    const navContainer2 = navRef2.current;

    const toggleSyllabusButtonsVisibility = (entries) => {
      const isVisible = entries[0].isIntersecting;
      navContainer2.classList.toggle("sticky-section", isVisible);
    };


    const isSmallScreen = window.innerWidth < 767;

    // if (isSmallScreen) {
    //   const navContainer2Height = navContainer2.clientHeight;
    //   const navThreshold = 200 / navContainer2Height;


    //   const options = {
    //     threshold: [navThreshold],
    //   };

    //   if (navThreshold <= 0.5) {
    //     const navObserver = new IntersectionObserver(
    //       toggleSyllabusButtonsVisibility,
    //       options
    //     );
    //     navObserver.observe(navContainer2);
    //   } else {
    //     console.error("Syllabus threshold exceeds 1. Please adjust the value.");
    //   }


    // }
 
    return () => {
      const navObserver = new IntersectionObserver(
        toggleSyllabusButtonsVisibility
      );
      // navObserver.unobserve(navContainer2);
    };
  }, []);
 


  useEffect(() => {
    const countDownDate = new Date("April 27, 2023 10:00:00").getTime();

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(interval);
        // document.getElementById("time_counter").innerHTML = "<h1>Batch for Data Science & AI Live classes starts on</h1> <div class='days'><h3>11th May</h3></div>";
      } else {

        {
        setCountdownText(


          `<h3>Live Classes for the Data Science & AI Master Course Starts From</h3> 
          <div class='days'><h3>11th May</h3><span></span></div>`
        
        );
        }


        {

          setCountdownText(


            `<h3>Live Classes for the Data Science & AI Course Starts in</h3> 
          <div class='days'><h3>${days}</h3><span>Days</span></div>
          <div class='hours'><h3>${hours}</h3><span>Hours</span></div>
          <div class='minutes'><h3>${minutes}</h3><span>Minutes</span></div>
          <div class='second'><h3>${seconds}</h3><span>Seconds</span></div>`
          );
        }

      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <title>Data Science Course Online (2024)</title>
      <meta
        name="description"
        content="Join our online Data Science Course to help you master Python, ML, and AI with placement assistance. Become a certified Data Scientist in 7 months."
      />
      <link
        rel="canonical"
        href="https://logicmojo.com/datascience-course"
      />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Data Science Course Online (2024)"
      />
      <meta
        property="og:description"
        content="Join our online Data Science Course to help you master Python, ML, and AI with placement assistance. Become a certified Data Scientist in 7 months."
      />
      <meta
        property="og:url"
        content="https://logicmojo.com/datascience-course"
      />
      <meta property="og:site_name" content="Logicmojo" />
      <meta
        property="article:modified_time"
        content="2024-01-5T11:45:44+00:00"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:image"
        content="https://logicmojo.com/assets/dist/new_pages/images/datas.png"
      />
      <meta name="twitter:label1" content="Est. reading time" />
      <meta name="twitter:data1" content="1 minute" />

      <div className="fulltrakmenu sticky secondmenu " id="secondmenu">
        <div className="container d-flex justify-content-between align-items-center" style={{ paddingTop: 10 + "px" }}>
          <a className="navbar-brand" href="/">
            <img width={150} src="assets/images/LogicmojoLogo.webp" alt="Logicmojo Logo" className="new_logo " />
          </a>
          <div className="ml-auto">
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
              className="enroll-btn btn btn-danger"
            >
              <b>Request a Call</b>
            </a>
          </div>
        </div>
      </div>

      <DataScienceBanner />
     <HoliDiscount />
      <CourseHighlights />
      
      <TestimonialsSection />
      


      <div className="banner-aistrip" >
        <div className="container ">
          <ul>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon1.png" alt="Salary Hike After Completing this Data Science Course" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14}}><b>120% Average Hike</b></div>
                <div style={{ fontsize: 14 }}>in Job Switch</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon2.png" alt="Data Science Course Duration - 7 Months" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>7 Months</b></div>
                <div style={{ fontsize: 14 }}>Weekend Live Classes</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon3.png" alt="Data Science Projects" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>Project Based Learning</b></div>
                <div style={{ fontsize: 14 }}>Real Time Projects</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon4.png" alt="Data Science Job Assistance" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>Job Assistance</b></div>
                <div style={{ fontsize: 14 }}>100% Placements</div>
              </div>
            </li>
            <li style={{ fontsize: 14 }}>
              <span>
                <img src="assets/images/banner-aistrip-icon5.png" alt="EMI Option for Enrollment" />
              </span>
              <div className="banner-aistrip-text">
                <div style={{ fontSize: 14 }}><b>Starts at INR 4,500/month*</b></div>
                <div style={{ fontsize: 14 }}>EMI Options Available</div>
                <br/>
               
              </div>
              
            </li>
           
          </ul>
        </div>
      
      </div>
     
      <div
        id="time_counter"
        // dangerouslySetInnerHTML={{ __html: countdownText }}
      >
        
      </div>
      
      
      
      
          
      

      <div className="container">
     
      <HiringOrganizations />
      </div>
      


      <section
        className="sec-navbar"
      >
        {/* <div className="container  d-md-none d-flex justify-content-between align-items-center" style={{ paddingTop: 10 + "px" }}>
          <a className="navbar-brand" href="/">
            <img width={150} src="assets/images/LogicmojoLogo.png" alt="" className="new_logo d-md-none d-block" />
          </a>
          <div>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
              className="enroll-btn btn btn-danger"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div> */}


<nav className="container d-flex justify-content-between align-items-center">
  
          <ul id="scrollble-ul-page">

          

            <li className={`scrollble-tab-li ${isVisibleOverview && !isVisibleCoursereview ? "active" : ""}`}>
              <a href="#Overview">Overview</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCoursereview && !isVisibleSyllabus ? "active" : ""}`}>
              <a href="#coursereview">Reviews</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleSyllabus ? "active" : ""}`}>
              <a href="#syllabus">Syllabus</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleCertification && !isVisibleProject ? "active" : ""}`}>
              <a href="#certification">Certification</a>
            </li>

             <li className={`scrollble-tab-li ${isVisibleProject && !isVisibleMentor ? "active" : ""}`}>
              <a href="#projects">Projects</a>
            </li>

            <li className={`scrollble-tab-li ${isVisibleMentor ? "active" : ""}`}>
              <a href="#mentor">Mentor</a>
            </li>
            
            <li className={`scrollble-tab-li ${isVisiblePlacement && !isVisibleFee ? "active" : ""}`}>
              <a href="#placement">Placement</a>
            </li>         
            
            <li className={`scrollble-tab-li ${isVisibleFee && !isVisibleFaq ? "active" : ""}`}>
              <a href="#fee">Fee</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleFaq && !isVisibleContact  ? "active" : ""}`}>
              <a href="#faq">FAQs</a>
            </li>
            <li className={`scrollble-tab-li ${isVisibleContact ? "active" : ""}`}>
              <a href="#contact">Contact</a>
            </li>
            <li className="applynow">
          <a
          target="_default"
          href="https://logicmojo.com/Book-Call-Back"
          className="enroll-btn btn btn-danger"
        >
          <b>Request a Call</b>
        </a>
          </li>

          </ul>
          {/* -- this one 
          <div style={{ paddingLeft: 10 + "px" }}>
            <a
              target="_default"
              href="https://calendly.com/logicmojo/30min"
              className="enroll-btn btn btn-danger"
            >
              <b>Register Yourself!</b>
            </a>
          </div>
      */}
        </nav>
        <TopBar />
      </section>
     <PremiumFeeBatchDetails />
     
      <section  ref={overviewSection} className="btn-center-section" id="Overview">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
      

{/*
      <section ref={overviewSection} className="whymakesnew" id="Overview">
        <div className="container ">
        <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}>
         <b> Data Science Course</b><b style={{color:"#9769ef" }}> Overview</b> 
          </h2>
          <br></br>
          <p style={{ fontSize: 14 }}>
          Are you ready to become a data science expert in just 7 months? Our live instructor led data science course is designed to provide you your learning and career growth. Master essential skills such as <a href="https://logicmojo.com/python-for-data-science">Python</a>, <a href="https://logicmojo.com/sql-interview-questions">SQL</a>, <a href="https://logicmojo.com/machine-learning-interview-questions">Machine Learning</a>, <a href="https://logicmojo.com/tableau-interview-questions">Tableau</a>, Generative AI, <a href="https://logicmojo.com/what-is-deep-learning">Deep Learning</a>, and other in-demand skills that top companies are actively seeking.
         </p>
         <p style={{ fontSize: 14 }}>
         You will get Experience in one of the best data science courses in India which features an industry aligned syllabus that includes practice labs sessions, 10+ real-world <a href="https://logicmojo.com/data-science-projects">data science projects</a> and mock interview sessions. Additionally, We develop crucial workplace skills and soft skills with the support of our dedicated Career Services Team.
         </p>
         <p style={{ fontSize: 14 }}>
         With our unique job Assistance and close ties with the industry, you will be fully prepared to break into the data science industry. Get in touch with our career counsellor today to check your eligibility for our comprehensive data science course and take the first step towards a growing career as a highly skilled data scientist.
         </p>
         <br/>
        
        </div>
      </section>


      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
     
     
      
      <div className="ourclientbg-new" >
        <div className="container">
          <h3 style={{ fontSize: 25}}><b style={{ fontSize: 25, color:"#9769ef" }}> Data Science Alumni</b> Excel in Leading Companies</h3>

          <OwlCarousel
            className="owl-theme"
            loop
            margin={20}
            nav
            navText={[
              " ",
              " ",
            ]}
            responsive={{
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              1000: {
                items: 3
              }
            }}
          >
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/makemytrip.jpeg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/vmware.jpg" alt="" />
              <img src="assets/images/intuit.jpg" alt="" />
              <img src="assets/images/meta.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/oracle.jpg" alt="" />
              <img src="assets/images/ciscologo.jpg" alt="" />
              <img src="assets/images/adobe.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/intel.jpg" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/paypal.jpg" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/sony.jpg" alt="" />
            </div>
          </OwlCarousel>

        </div>
      </div>
       */}
      <section className="datareviewsbg" id="coursereview">
        <div ref={coursereviewSection} className="whatpeoplesaybg" id="Review">

        



        

        </div>
        <div >
          <TestimonialReviews />
     
      </div>
        {/*
        <div className="container">
          <h3>Learner Reviews for our Data Science Programs</h3>

          <div className="row">
            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/shivam.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Shivam Bajpai</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  I recently wrapped up a data science course and would like to
                  discuss my impressions and insights from the program. Overall,
                  I believe the course is a great asset for those interested in
                  entering the data science field or improving their current
                  abilities. The course curriculum was skillfully crafted,
                  encompassing all key aspects of data science, such as
                  statistics, Python, machine learning, data analysis, and
                  large-scale data processing. The lessons were thoughtfully
                  arranged, beginning with fundamental concepts and gradually
                  advancing to more complex topics, making it simple to
                  comprehend and follow the material.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/puneet.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Puneet</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  I recently completed an online data science course and would
                  like to share my feedback and experiences about the program.
                  The course proved to be an exceptional learning opportunity
                  for those looking to delve into data science or improve their
                  existing skills in the field. The course was meticulously
                  structured, encompassing a broad array of crucial data science
                  topics.The instructors were not only experts in their
                  respective fields but also highly accessible and supportive.
                  They offered clear explanations and promptly addressed any
                  questions or concerns
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/diwakar.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Diwakar Choudhary</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  A key aspect of the data science course was its emphasis on
                  practical, hands-on learning experiences. Throughout the
                  program, students were tasked with completing a variety of
                  assignments, quizzes, and projects, encouraging them to apply
                  their newfound knowledge to real-world scenarios. This
                  approach not only deepened my understanding of the subject
                  matter but also allowed me to build a compelling portfolio to
                  showcase my skills to prospective employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/afnaan.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Afnaan Rafique</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  The online format of the data science course provided the
                  flexibility to learn at my own pace and according to my
                  schedule. This was particularly beneficial for individuals,
                  like myself, balancing work, family, and other commitments,
                  making it an appealing option for learners with varying levels
                  of availability.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/piyush.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Piyush Mittal</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  A crucial element of the data science course focused on
                  providing practical, experiential learning opportunities.
                  During the program, students engaged in numerous tasks, tests,
                  and projects that pushed them to utilize their acquired
                  knowledge in real-life situations. This method not only
                  enriched my comprehension of the topics but also enabled me to
                  create an impressive portfolio to demonstrate my abilities to
                  potential employers.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/priya.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Priya Singh</h3>
                    <p style={{ fontsize: 14 }}>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p style={{ fontsize: 14 }}>
                  The digital structure of the data science course allowed for
                  the adaptability to study at a pace and schedule that suited
                  me. This proved to be especially advantageous for people,
                  including myself, who had to juggle work, family, and other
                  responsibilities, rendering it an attractive choice for
                  students with diverse time commitments.
                </p>
              </div>
            </div>
            <center>
              <a
                target="_default"
                href="https://www.google.com/search?q=logicmojo+review&oq=log&aqs=chrome.1.69i65j69i59j46i39i175i199j69i60l4j69i65.1921j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"
                className="btn btn-link collapsed"
              >
                View more reviews
              </a>
            </center>
          </div>
        </div>
                                */}
      </section>
      {/* Video section from youtube */}
      
      <WhoShouldJoin />
      
      <CareerOutcomes />
      <Timeline />
      <section ref={syllabusInDetail} className="careerservices-new" id="syllabus">
      <div className="container clearfix">
        <CareerServicesAI />
        </div>
      </section>
      
      <section className="program-highlights" id="tools">
        <div className="container">
        <div className="row" >
        <div className="container clearfix"><br/><br/>
        
        <h2 className="faq-heading"><b>4. Which Tools You will learn</b></h2><br/><br/>
          <p style={{ fontSize: 14 }}>During the preparation process in the course, you'll become proficient with a variety of tools that are essential for data science, <a href="https://logicmojo.com/big-data-analytics">big data</a>, <a href="https://logicmojo.com/power-bi-interview-questions">powerBI</a> and <a href="https://logicmojo.com/tableau-interview-questions">tableau</a>. Here are some of the key tools you will learn</p>

          <div className="row"  >       
        <div className="col-md-3 col-4">
          <div className="highlight-card1">

            <img src="assets/images/icons/5.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>Python</h3>
          </div>
        </div>

        <div className="col-md-3 col-4">
          <div className="highlight-card1">

            <img src="assets/images/icons/12.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>NumPy</h3>
          </div>
        </div>

        <div className="col-md-3 col-4">
        
          <div className="highlight-card1">

            <img src="assets/images/icons/10.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>Scikit-learn</h3>
          </div>
         
        </div>

        <div className="col-md-3 col-4">
          <div className="highlight-card1">
            <img src="assets/images/icons/4.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>Pytorch</h3>
          </div>
        </div>

        <div className="col-md-3 col-4">
          <div className="highlight-card1">

            <img src="assets/images/icons/8.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>Matplotlib</h3>
          </div>
        </div>

        <div className="col-md-3 col-4">
          <div className="highlight-card1">
            <img src="assets/images/icons/6.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>TensorFlow</h3>
          </div>
        </div>

        <div className="col-md-3 col-4">
          <div className="highlight-card1">
            <img src="assets/images/icons/7.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>Keras</h3>
          </div>
        </div>

        <div className="col-md-3 col-4">
          <div className="highlight-card1">

            <img src="assets/images/icons/11.webp" height="64" width="74" alt="img" />
            <h3 style={{ fontSize: 14 }}>OpenCV</h3>
          </div>
        </div>

      <div className="col-md-3 col-4">
        <div className="highlight-card1">
          <img src="assets/images/icons/9.webp" height="64" width="74" alt="img" />
          <h3 style={{ fontSize: 14 }}>NLTK</h3>
        </div>
      </div>

      <div className="col-md-3 col-4">
        <div className="highlight-card1">
          <img src="assets/images/icons/3.webp" height="64" width="74" alt="img" />
          <h3 style={{ fontSize: 14 }}>Gbard</h3>
        </div>
      </div>

      <div className="col-md-3 col-4">
        <div className="highlight-card1">
          <img src="assets/images/icons/1.webp" height="64" width="74" alt="img" />
          <h3 style={{ fontSize: 14 }}>ChatGPT</h3>
        </div>
      </div>

      <div className="col-md-3 col-4">
        <div className="highlight-card1">
          <img src="assets/images/icons/2.webp" height="64" width="74" alt="img" />
          <h3 style={{ fontSize: 14 }}>DALL-E-2</h3>
        </div>
      </div>
      </div>

      </div>

</div>


        </div>
      </section>
<section>
    <CommunityPage />
    </section>
      <section  ref={certificationSection} className="certificate-companies" id="certification">
        <Certificates />

        {/* <hr />
        <div className="container ">
          
          <div className="certificate-companies-text">
            <h2 style={{ fontSize: 29}}>Data Science <b style={{ fontSize: 29, color:"#9769ef"}}>Certification</b></h2>
            <h3 style={{ fontSize: 20}}> Data Science Certification Advantage </h3>
              <br></br>

             
            <ul>
              <h3><li style={{ fontsize: 14 }}>
                <b>Get Ahead with Logicmojo's Master Data Science Certificate</b>
              </li></h3>
              <p style={{ fontSize: 14 }}>
              Earn your professional data science certification with project experience through our accredited data science course. 
              Receive both Data Scientist and Company project certificates to enhance your career prospects in the field of data science. 
              Gain exclusive access to industry-leading expert masterclasses..
              </p>
              <h4><li style={{ fontsize: 14 }}>
                <b>Differentiate yourself with a Masters Certificate</b>
              </li></h4>
              <p style={{ fontSize: 14 }}>
                The understanding and Data Science abilities you've developed
                through projects, simulations, and case studies will put you
                ahead of others.
              </p>
             
            </ul>
            <a target="default" href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view">
              Download Brochure
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
          <div className="certificate-companies-img">
            <img style={{ border: '1px solid #000' }} src="assets/images/certificate-companies.png" alt="" />
          </div>
          <br/><br/>

        </div>


        <div className="container">

                  <div className="certificate-companies-text">
                  <ul>
                  <li style={{ fontsize: 14 }}>
                        <b>Project Experience Certification</b>
                      </li>
                      <p style={{ fontSize: 14 }}>
                        Share your Data Science Projects Certification on LinkedIn, Twitter, and
                        Facebook, enhance your resume, or display it proudly - let your
                        friends and colleagues know about your achievement
                      </p>
                  </ul>
                      </div>

                      <div className="certificate-companies-img">
                <img style={{ border: '1px solid #000' }} src="assets/images/Data Science Certification.jpg" alt="" />
                
                </div>


                    
          </div> */}
         
      </section>
      
     

      
    
     

    

      
      
     

      <section ref={projectSection} className="projectsnewbg" id="projects">
        <div className="container ">

          <center>
            <br/><br/><h2 className="faq-heading"><b>6. Industry Projects</b> 
            </h2>
          </center>
          <br></br>
          <p style={{ fontSize: 14 }}>
            <a href="https://logicmojo.com/data-science-projects">Projects</a> will be a part of your Certification in Data Science
            Course to consolidate your learning.
            It will ensure that you have real-world experience in Data Science
            Field.
          </p>
          <div className="projectsnewbg-practice">
            <ul>
              <li style={{ fontsize: 14 }}>
                <img src="assets/images/practice-icon.png" alt="Data Science Essential Tools" />
                <h3 style={{ fontsize: 17,color: "#f91c4b" }}>Practice 20+</h3>
                <p style={{ fontsize: 14 }}>Essential Tools</p>
              </li>
              <li style={{ fontsize: 14 }}>
                <img src="assets/images/designed-icon.png" alt="" />
                <h3 style={{ color: "#2aacf6" }}>Designed by</h3>
                <p style={{ fontsize: 14 }}>Industry Experts</p>
              </li>
              <li style={{ fontsize: 14 }}>
                <img src="assets/images/get-icon.png" alt="Industry Projects" />
                <h3 style={{ color: "#1fcd71" }}>Industry Projects</h3>
                <p style={{ fontsize: 14 }}>Work Experience</p>
              </li>
            </ul>
          </div>

          <div className="projectsnewbg-bottom clearfix" ref={navRef}>
            <ul className="nav nav-tabs sticky-nav center-nav" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab012">
                  Beginner
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab013">
                  Intermediate
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab014">
                  Advance
                </a>
              </li>
            </ul>
            <div className="tab-content">
              <div id="tab012" className="tab-pane active">
                <Projects id="1" />
                {/* <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Face Detection is an initiative to create a computer
                        vision model that can automatically detect and locate
                        human faces within images or video frames.The goal of
                        this project is to enable machines to recognize and
                        analyze human faces in various contexts, such as
                        security, entertainment, or social media.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Artificial intelligence-powered chatbot that can
                        communicate with humans in a natural language.project
                        involves designing, developing, and deploying a chatbot
                        that can perform specific tasks or answer questions for
                        users. The chatbot can be used for various purposes,
                        such as customer support, sales, marketing, or personal
                        assistance
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Restaurant revenue prediction project is an initiative
                        to create a machine learning model that can forecast the
                        revenue of a restaurant based on various factors such as
                        customer footfall, menu items, prices, and marketing
                        promotions. The goal of this project is to help
                        restaurant owners make data-driven decisions to increase
                        their revenue and profitability.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        climate change impacts project on the global food supply
                        is an initiative to investigate how climate change will
                        affect food production, distribution, and consumption
                        worldwide. The project aims to provide insights into how
                        these impacts may vary by region, crop type, and
                        socio-economic factors, and to identify potential
                        strategies for adaptation and mitigation.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Credit card fraud detection using classification
                        algorithms is an initiative to create a machine learning
                        model that can automatically detect fraudulent
                        transactions in credit card transactions. The goal of
                        this project is to enable financial institutions to
                        detect and prevent fraud and protect their customers'
                        financial security.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p style={{ fontsize: 14 }}>
                        Water quality project using the random forest algorithm
                        in data science is an initiative to create a machine
                        learning model that can predict water quality parameters
                        such as pH, dissolved oxygen, biochemical oxygen demand
                        (BOD), and total suspended solids (TSS). Predict water
                        quality using datasets.
                      </p>
                    </div>
                  </div>
                </OwlCarousel> */}
              </div>

              <div id="tab013" className="tab-pane fade">
                <Projects id="2" />
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                  
                </OwlCarousel>
              </div>
              <div id="tab014" className="tab-pane fade">
                <Projects id="3" />
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={20}
                  nav
                  navText={[" ", " "]}
                  responsive={{
                    0: {
                      items: 1,
                    },
                    600: {
                      items: 1,
                    },
                    1000: {
                      items: 3,
                    },
                  }}
                >
                
                  
                  
                  
                </OwlCarousel>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" id="curriculum">
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      <section ref={placementSection} className="careerservices-new" id="placement">
      <div className="container clearfix">
        <CareerServices />
        </div>
      </section>
      

      

    
    
      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      <section ref={mentorSection} id="mentor" >
  
        <div className="container ">
          
          <h2 className="faq-heading"><b><br/><br/>
          7. Meet Our Mentors </b>
          </h2>
          <MentorsProfile ytUrl="https://www.youtube.com/embed/qrjWdidQK-c?si=3hEbSTq0aE7A8rFr" />
          <div className="review_scroll_sec"  id="mentors">

            <div className="review_scroll_inner">


            <div className="faculty-box position-relative d-flex flex-column">

                    <div className="body">
                      <h4 className="name">Mohammed Shirhaan</h4>
                      <p className="title">
                        Lead Architect WalMartLabs
                      </p>
                      <p style={{ fontSize: 14 }} className="description">
                      Mohammed Shirhaan is currently working as a Lead Architect at WalMartLabs.
                      He has a vast experience of teaching Data Science.
                      </p>
                    </div>

                    <footer className="d-flex position-relative justify-content-start align-items-center">
                      <img src="https://logicmojo.com/assets/dist/new_index_design/images/InformaticaLogo.png" />
                      <img
                        className="faculty-img position-absolute"
                        src="https://logicmojo.com/assets/dist/new_index_design/images/Mohammed-Shirhaan.png"
                      />
                      <a
                        className="inline-block linkedin-icon position-absolute"
                        href="https://www.linkedin.com/in/mshirhaan/"
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 16 16"
                          class="bg-white text-[#0077B6]"
                          height="18"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                        </svg>
                      </a>
                    </footer>
                    </div>


                    <div className="faculty-box position-relative d-flex flex-column">

                <div className="body">
                  <h4 className="name">Mohamed Shirhaan</h4>
                  <p className="title">
                    Senior Data Science Mentor
                  </p>
                  <p style={{ fontSize: 14 }} className="description">
                  Shirhaan working as R & D Group of WalmartLabs as senior Developer.
                  </p>
                </div>

                <footer className="d-flex position-relative justify-content-start align-items-center">
                  <img src="assets/images/walmarticon.png" />
                  <img
                    className="faculty-img position-absolute"
                    src="assets/images/mac/Mohammed-Shirhaan.jpg"
                  />
                  <a
                    className="inline-block linkedin-icon position-absolute"
                    href="https://www.linkedin.com/in/mshirhaan/"
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      class="bg-white text-[#0077B6]"
                      height="18"
                      width="18"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                    </svg>
                  </a>
                </footer>
                </div>

                <div className="faculty-box position-relative d-flex flex-column">

                  <div className="body">
                    <h4 className="name">Sankalp Jain</h4>
                    <p className="title">
                      Senior Mentor Data Scientist
                    </p>
                    <p style={{ fontSize: 14 }} className="description">
                    Sankalp is From IIT Kgp worked as a senior developer in Odin AI as a Data Scientist.
                    Experienced in the field of Data Scientist & AI.
                    </p>
                  </div>

                  <footer className="d-flex position-relative justify-content-start align-items-center">
                    <img style={{ height: "110px",width:"190px" }}
                    src="assets/images/companyLogo/iitKGP.jpeg" />
                    <img
                      className="faculty-img position-absolute"
                      src="assets/images/mac/Sankalp.jpeg"
                    />
                    <a
                      className="inline-block linkedin-icon position-absolute"
                      href="https://www.linkedin.com/in/sankalp-jain-iitkgp/"
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 16 16"
                        class="bg-white text-[#0077B6]"
                        height="18"
                        width="18"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
                      </svg>
                    </a>
                  </footer>
                  </div>



                  <div className="faculty-box position-relative d-flex flex-column">

<div className="body">
  <h4 className="name">Ravi Singh</h4>
  <p className="title">
    Senior Mentor Data Scientist
  </p>
  <p style={{ fontSize: 14 }} className="description">
  Ravi has more than 14 years of experience and has worked on multiple projects in data science and machine learning, as well as in business analytics.

  </p>
</div>

<footer className="d-flex position-relative justify-content-start align-items-center">
  <img src="assets/images/walmarticon.png" />
  <img
    className="faculty-img position-absolute"
    src="assets/images/ravi-singh.jpg"
  />
  <a
    className="inline-block linkedin-icon position-absolute"
    href="https://www.linkedin.com/in/ravi-singh-a430ab29/"
  >
    <svg
      stroke="currentColor"
      fill="currentColor"
      stroke-width="0"
      viewBox="0 0 16 16"
      class="bg-white text-[#0077B6]"
      height="18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path>
    </svg>
  </a>
</footer>
</div>

            </div>
          </div>

        </div>
      </section>


      <ComparisonWithOther />
      
      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
    
      <div className="howtoapply-new" ref={feeSection}>
        <div className="container ">
          <h2 className="faq-heading">
          <b>9. How to Enroll ?</b> 
          </h2>
          <div className="row">
            <div className="col-lg-8">
              <div className="howtoapply-new-left">
                <ul>
                  <li style={{ fontsize: 14 }}>
                    <p>Step 1</p>
                    <h3>Submit Application</h3>
                    <p style={{ fontsize: 14 }}>
                      Book calender call with our senior data scientist
                    </p>
                  </li>
                  <li style={{ fontsize: 14 }}>
                    <p>Step 2</p>
                    <h3>Application Review</h3>
                    <p style={{ fontsize: 14 }}>
                      Data scientist will review your profile & answer all your queries
                    </p>
                  </li>
                  <li style={{ fontsize: 14 }}>
                    <p>Step 3</p>
                    <h3>Admission</h3>
                    <p style={{ fontsize: 14 }}>
                      Candidate can apply for Online Live classes for 8 months
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="howtoapply-new-right">
                <center><h3 style={{ fontSize: 25 }}>Apply For Live Course</h3></center>
                <div className="howtoapply-new-rightform">
                  <form>
                    <div className="row">

                      <div className="form-group col-lg-12">
                        <input
                          type="submit"
                          className="submitbtn"
                          value="Apply For Live Classes"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section  className="programfeenew" id="fee">
        <div className="container ">
          <h2 className="faq-heading" ><b>10. Course Fee</b> ?</h2>
          <div className="programfeenew-inner">
            <div className="programfeenew-inner-left">
              <div className="programfeenew-inner-price">
                <h3 style={{ fontsize: 14 }}>Total Fee</h3>
                <h4>₹ 54,000</h4>
              </div>
            </div>
            <div className="programfeenew-inner-right">
              <p>No Cost EMI</p>
              <div className="d-flex align-items-center justify-content-between">
                <p>
                  <span>As low as</span> ₹ 4,500/month
                </p>
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
                >
                  Apply now
                </a>
              </div>
              <p style={{ fontsize: 14 }}>
                We have partnered with the following financing companies to
                provide competitive finance options at 0% interest rate with no
                hidden costs...
              </p>
              <ul>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo1.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo2.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo3.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo4.png" alt="" />
                </li>
                <li style={{ fontsize: 14 }}>
                  <img src="assets/images/feelogo5.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <div className="eligibility-criteria-row" >
        <div className="container ">
          <div className="row">
            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h3 style={{ fontSize: 25 }}>What Is the <b style={{ fontSize: 25, color:"#9769ef" }}>Eligibility</b> Criteria for the Data Science Course?</h3>
                <ul className="eligibilitylist1">
                  <h4><li style={{ fontsize: 14 }}>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon1.png"
                        alt=""
                      />
                    </span>
                    A bechelor's degree with an average of 50% or higher marks
                  </li></h4>
                  <h4><li style={{ fontsize: 14 }}>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon2.png"
                        alt=""
                      />
                    </span>
                    Basic understanding of programming concepts and mathematics
                  </li></h4>
                  <h4><li style={{ fontsize: 14 }}>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon3.png"
                        alt=""
                      />
                    </span>
                    2+ years of work experience preferred
                  </li></h4>
                </ul>
              </div>
            </div><br/>

            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h3 style={{ fontSize: 25 }}><b style={{ fontSize: 25, color:"#9769ef" }}>Who can apply</b> for the Data Science course?</h3>
                <ul className="eligibilitylist2">
                  <h4><li style={{ fontsize: 14 }}>Software engineers</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>IT Professionals</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>Data Professionals</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>Business Analysis</li></h4>
                  <h4> <li style={{ fontsize: 14 }}>Product Managers</li></h4>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>
      <br />
      <div ref={faqSection}>
      <FAQ />
      </div>

     {/* <section className="getcertfiedbgnew" id="Overview">
        <div className="container ">
          <div className="getcertfiedbgnew-inner">
            <center>
              <h2 style={{ fontSize: 25 }}>
              What Does Logicmojo <b style={{ fontSize: 25, color:"#9769ef" }}>Data Science Certification Program</b> Offer?
              </h2>
            </center>
            <br />
            <br />
           
            <div className="row justify-content-center">


              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-laptop" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>100% Live Online Classes</h3>
                  <div style={{ fontsize: 14 }}>
                  Faculty led Live Interactive online course on weekend &amp;
                    Live doubt sessions on Weekdays
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>Build Work Experience</h3>
                  <div style={{ fontsize: 14 }}>
                    Don't just Learn, Apply your learnings - work with companies
                    project.Real-world experience by working on live projects
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-briefcase" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>Assured Job Assistance</h3>
                  <div style={{ fontsize: 14 }}>
                    Secure a guaranteed job referral to leading companies and
                    startups, and kickstart your career in data science, AI
                    &amp; Machine Learning.
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-6">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-check-square" aria-hidden="true"></i>
                  <h3 style={{ fontsize: 14 }}>Domain Specialization</h3>
                  <div style={{ fontsize: 14 }}>
                  Leverage your prior work experience for relevant career transition &amp; Aim for higher salary hikes.
                  </div>
                </div>
              </div>




            </div>
          </div>
        </div>
      </section>/*}
      <br/><br/>
{/*
  Ravi Changes
*/}
      

    

     






      {/*
      <section className="relatedcourses">
        <div className="container ">
          <h3 style={{ fontSize: 25 }}>Data Science Course Faculty</h3>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/ravi-singh.jpg" />
                </div>

                <h3 className="name">Ravi Singh</h3>
                <p className="title">Experinced Senior Faculty Data Science</p>
                <p className="description">
                  Ravi has been part of multiple companies, gaining a wide array
                  of knowledge in data science. His background involves handling
                  various data kinds, applying diverse analysis methods.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/diwakar.png" />
                </div>

                <h3 className="name">Diwakar Choudhary</h3>
                <p className="title">Senior Faculty Member Data Science</p>
                <p className="description">
                  Diwakar has collaborated with numerous organizations, amassing
                  an extensive scope of expertise in data science. His
                  experience encompasses managing an assortment of data types
                  and employing a range of analytical approaches.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Vishal.jpeg" />
                </div>
                <h3 className="name">Vishal Gupta</h3>
                <p className="title">Faculty Of Data Science</p>
                <p className="description">
                Vishal has partnered with countless companies, building up
                  an impressive depth of proficiency in the data science field.
                  His experiences involve dealing with numerous data categories
                  and applying a wide spectrum of analytical techniques.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
                                */}



    
    <ContinuousSlider />
      

      <section className="relatedcourses"  id="blog">
        <div className="container ">
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}>11. Data Science Blogs</h2>
          <OwlCarousel
            className="owl-theme with-nav"
            loop
            margin={20}
            nav
            navText={[
              " ",
              " ",
            ]}
            responsive={{
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              1000: {
                items: 3
              }
            }}
          >



            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-interview-questions"
                >
                  <img src="assets/images/data-science-interview.jpeg" alt="" />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Data Science Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-introduction"
                >
                  <img
                    src="assets/images/mac/what-is-data-science-Intro.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Introduction : What is Data Science</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/machine-learning-interview-questions"
                >
                  <img
                    src="assets/images/mac/machine-learning-interview-question.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Machine Learning Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-scientist-salary"
                >
                  <img
                    src="assets/images/mac/Data-Scientist-Salary.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>What is Data Scientist Salary in India</h3>
                </div>
              </div>
            </div>

          </OwlCarousel>
        </div>
      </section>


  


   <section className="city-section">
        <div className="container ">
          <div className="row">
            <div className="col-lg-8 master-page-city-wrapper">
              <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}>
                <strong>
                  12. Find Data Science Course in Other Regions
                </strong>
              </h2>
              <div className="city-link-container">
                <Link
                  title="Data Science Course in Pune"
                  to="/Data-Science-Course-in-Pune"
                >
                  Pune
                </Link>
                <Link
                  title="Data Science Course in Bangalore"
                  to="/data-science-course-training-in-bangalore"
                >
                  Bangalore
                </Link>

               
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      

      
      

      <section className="btn-center-section" >
        <center><div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
            href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
            className="btn btn-danger secondmenu_btn"
          >
            <b>Apply For Live Classes</b>
          </a>
        </div></center>
      </section>

      <section ref={contactSection} className="supportbgnew" id="contact">
        <div className="container ">
          <h2 style={{ fontSize: '32px', fontFamily: "'DM Serif Display', serif" }}>Contact US</h2>
          <div className="supportbgnew-inner">
            <div className="supportbgnew-inner-img">
              <img src="assets/images/supportimg.png" alt="" />
            </div>
            <div className="supportbgnew-inner-content">
              <p>Got more questions?</p>
              <h3>Talk to our team directly</h3>
              <p style={{ fontsize: 14 }}>
                Reach us and a learning consultant will get in touch with you
                shortly
              </p>
              <a href="">
                <i className="fa fa-whatsapp"></i> Enquire now
              </a>
              <a href="" style={{ background: "#1a64c0" }}>
                <i className="fa fa-whatsapp"></i> +91 80889-75867
              </a>
            </div>
          </div>
          <center className="clearfix float-left w-100">
            <div className="social-icons">

              <i className="fa fa-youtube-play"></i><a href="https://www.youtube.com/@logicmojo/videos" target="_blank">
                Youtube
              </a>

              <i className="fa fa-facebook-f"></i><a href="https://www.facebook.com/logicmojo/" target="_blank" >
                Facebook
              </a>


              <i className="fa fa-twitter"></i><a href="https://twitter.com/logic_mojo" target="_blank" title="Follow us on Twitter">
                Twitter
              </a>


              <i className="fa fa-linkedin-square"></i><a href="https://www.linkedin.com/company/82779427" target="_blank" title="Connect with us on LinkedIn">
                LinkedIn
              </a>


              <i className="fa fa-instagram"></i><a href="https://www.instagram.com/logicmojo/" target="_blank" title="Follow us on Instagram">
                Instagram
              </a>
            </div>
          </center>
        </div>
      </section>
      <Footer />

      <div className="footerai">
        <div className="container ">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <p style={{ fontsize: 14 }}>
                <img src="assets/images/logo.png" alt="" />
              </p>
             
            </div>
            {
              <div className="col-md-6 col-lg-4">
                <h3>Courses</h3>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Introduction-to-Data-Analytics">
                    Advance Data Science & AI Program
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Advance-Data-Science-ML-Program">
                    Advance AI & ML Program
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Master-data-Science-ai-program">
                    Master Degree Program For Data Science & AI
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/AI-Fundamental-for-Non-Data-Scientist">
                    AI Fundamental for Non Data Scientist
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Data-Science-Course-For-Managers">
                    Data Science Course For Managers
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Post-Graduate-Program-For-Data-Science">
                    Post Graduate Program For Data Science
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Basics-Introduction-to-Data-Science">
                    Basic Introduction to Data Science
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Introduction-to-Data-Analytics">
                    Introduction to Data Analytics
                  </Link>
                </p>
                <p style={{ fontsize: 14 }}>
                  <Link to="/Applied-Data-Science-with-Python">
                    Applied Data Science with Python
                  </Link>
                </p>
              </div>
            }
            
            
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h3>Project Innovation Lab Address</h3>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Pune</h4>
              <p style={{ fontsize: 14 }}>
                Sky Loft Group Floor, Creaticity Mall, Opposite Golf Course,
                Airport Rd, Shastrinagar, Yerawada, Pune, Maharashtra 411006
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Mumbai</h4>
              <p style={{ fontsize: 14 }}>
                Business Centre, 3rd Floor, vinkat House, Dinshaw Vacha Road,
                Churchgate, Mumbai, Maharashtra 400020
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Delhi</h4>
              <p style={{ fontsize: 14 }}>
                Business Centre Park, Arunachal Building, 8th Floor, Barakhamba
                Road, New Delhi 110001
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }}>Kolkata</h4>
              <p style={{ fontsize: 14 }}>
                Ambuja Neotia EcoCentre 5th Floor, EM-4,EM-Block, Sector 6
                Kolkata 700091
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }} className="mt-3">Hyderabad</h4>
              <p style={{ fontsize: 14 }}>
                NSL Centrum, Road No 1, Lane, Opp. Forum Mall Central Hub, KPHB
                4th Phase, Hyderabad, Telangana 500072
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4  style={{ fontsize: 14,color:"white" }} className="mt-3">Bangalore</h4>
              <p style={{ fontsize: 14 }}>
                #23, Above Veena Mobiles, 14th Main Road, Opp-White House,
                Sector 2, Hsr Layout, Bangalore 560102
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h4 style={{ fontsize: 14,color:"white" }} className="mt-3">Chennai</h4>
              <p style={{ fontsize: 14 }}>
                Cessanana Business Centre, Phone Booth, 3rd Floor, 39/12 Haddows
                Road, Nungambakkam, Chennai 600 006
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            {/* <div className='col-md-6 col-lg-3'>
                <h3>Bangalore</h3>
                <p style={{ fontsize: 14 }}><a href="#">Data Science Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Bangalore</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Bangalore</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Hyderabad</h3>
                <p style={{ fontsize: 14 }}><Link to="/Data-Science-Course-Hydrabad">Data Science Course Training In Hyderabad</Link></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Hyderabad</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Hyderabad</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Dubai</h3>
                <p style={{ fontsize: 14 }}><a href="#">Data Science Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Dubai</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Dubai</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Delhi</h3>
                <p style={{ fontsize: 14 }}><a href="#">Data Science Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Machine Learning Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Data Analytics Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Business Analytics Course Training In Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Artificial Intelligence AI Course Training Delhi</a></p>
                <p style={{ fontsize: 14 }}><a href="#">Full-Stack Software Developer Course In Delhi</a></p>
            </div> */}
          </div>

          <hr />

          <div className="row">
            <div className="col-lg-12">
              <p className="m-0">© 2024 LOGICMOJO. ALL RIGHTS RESERVED</p>
            </div>
          </div>
        </div>
      </div>

      {/*<div className="modal fade" id="counsellingpopup">
        <div className="modal-dialog modal-lg modal_width">
          <div className="modal-content">
            <div className="modal-body">
              <div className="counsellingpopupbg">
                <button type="button" className="close" data-dismiss="modal">
                  &times;
                </button>
                <div className="counsellingpopupbg-img">
                  <img
                    loading="lazy"
                    src="assets/images/counselling_new.jpeg"
                    alt="counselling_new"
                  />
                </div>
                <div className="counsellingpopupbg-form counseling_thanks">
                  <h3>
                    Schedule Call Back From Experts For Live Classes Queries
                  </h3>

                  <iframe
                    src="https://logicmojo.com/counsellingpopup"
                    className="counsellingpopupbgIframe"
                    title="popup form"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>*/}
      {/*
      <div className="modal" id="welcomepopup">
        <div className="modal-header">
        <p style={{ fontsize: 14 }}><span className="yallowbox">Early Bird Discount &#127881;  </span></p>
          <button type="button" className="close" data-dismiss="modal">
            &times;
          </button>
        </div>

        <div className="modal-body">
         
          <p style={{ fontsize: 14 }}>
            Data Science, Machine Learning &amp; AI Course
            <br />
            <b>
              <a href="#" style={{ color: "#007bff" }}>
                (Duration: 7 months)
              </a>
            </b>
          </p>


          <p style={{ textAlign: "center" }}>
            <span className="yallowbox">15% OFF On All Courses</span>
          </p>

          <b>
            <p style={{ textAlign: "left" }}>
              <span>Batch starts from <u>26th April</u></span>
            </p>
          </b>
          <p style={{ fontsize: 14 }}>Weekend Batch : 9 AM - 12 PM (IST)</p>
        </div>

        <div className="modal-footer">
          <a
            target="_default"
            href="https://calendly.com/logicmojo/career-counselling-live-classes?month=2023-11"
            className="btn btn-primary"
          //data-toggle="modal"
          //data-target="#counsellingpopup"
          >
            <b>Apply Now</b>
          </a>
        </div>
      </div>
          */}


      <div className="footerstrip-formob">
        <a href="https://api.whatsapp.com/send?phone=+918088975867&amp;text=Hi%20Logicmojo">
          Chat with us{" "}
          <img
            src="assets/images/whatsapp logo.png"
            width="30"
          />
        </a>{" "}
        |{" "}
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
        >
          Call Back{" "}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&amp;usqp=CAU"
            width="30"
          />
        </a>
      </div>
      <div className="footerstrip">
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2024-04"
        >
          <span>
            <i className="fa fa-hand-o-right" aria-hidden="true"></i>{" "}
            <b>
              <u>+91 8088975867</u>
            </b>
          </span>
          <span>
            <i className="fa fa-volume-control-phone" aria-hidden="true"></i>{" "}
            <b>Talk To Our Tech Team</b>{" "}
          </span>
          <span>
            <i className="fa fa-question-circle" aria-hidden="true"></i> Any query
            related to live classes
          </span>
        </a>
      </div>
    </div>
  );
}

export default Home;
